const revealNewsletterButton = document.querySelector( '[data-reveal-newsletter]' );
const closeNewsletterButton = document.querySelector( '[data-close-newsletter]' );
const newsletterSignup = document.querySelector( '[data-newsletter-signup]' );

const toggleNewsletter = () => {
	const expanded = revealNewsletterButton.getAttribute( 'aria-expanded' );
	if ( expanded === 'true' ) {
		revealNewsletterButton.setAttribute( 'aria-expanded', 'false' );
		newsletterSignup.setAttribute( 'aria-hidden', 'true' );
		newsletterSignup.style.display = 'none';
	} else {
		revealNewsletterButton.setAttribute( 'aria-expanded', 'true' );
		newsletterSignup.setAttribute( 'aria-hidden', 'false' );
		newsletterSignup.style.display = 'block';
	}
}

revealNewsletterButton.addEventListener( 'click', toggleNewsletter );
closeNewsletterButton.addEventListener( 'click', toggleNewsletter );
